import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../../forms/FormMixin'
import { useConfirm } from '@/composables/useConfirm'
import { useUserStore } from '@/stores/user'
import useField from '@/composables/useField'
import { optionsGetter } from '@utils/helpers'
import { useModalOpener } from '@/composables/useModalOpener'
import {
  clientCreateResource,
  clientUpdateResource,
} from '@/services/clients.service'
  
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientCreateModal',
  props: {
  promise: Promise,
  close: Function,
  info: Object,
},
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const store = useUserStore()

const emit = __emit
const { $t } = useGlobal()
const load = ref(false) 
const dataIsSended = ref(false)
const form = ref({
  id: '',
  originalId: '',
  lps: '',
})

watch(() => props.info, () => {
  if(props.info) Object.keys(form.value).forEach(key => {
    if(props.info[key]) form.value[key] = props.info[key]
  })
}, {immediate: true, deep: true})

const currentResource = ref(props.info ? clientUpdateResource : clientCreateResource)

const request = (sendData: any, control: any) => {
  useSubmit( send(sendData, control), control)
}

const fields = ref([
  useField('originalId', $t('Client ID'), {readonly: props.info ? true : false, rules: 'min:2|max:255'}),
  useField('lps', $t('LP connections'), {
    component: 'd-control-multiselect',
    options: '',
    'show-labels': false,
    'track-by': 'id',
    'label-by': 'organizationName',
    'allow-empty': true,
    'open-direction': 'top',
    searchable: false,
    multiple: true,
  }),
])


const send = async (sendData: any, control: any) => {
  const preparedData = {
    ...sendData,
  }
  const question = $t('Сonfirm action')
  const title = $t('Successfully')
  const subtitle = props.info ? $t('All data is saved') : $t('A new Client is created')
  try {
      await useConfirm(question)
      load.value = true
      preparedData.lps = preparedData.lps.map( el => el.id) 
      const { redirectLink } = await currentResource.value.execute({ id: form.value?.id }, {
        ...preparedData,
      })
      dataIsSended.value = true
      load.value = false
      await useModalOpener({
      component: 'UiMessageModal',
      message:{
        title,
        subtitle,
        success: true,
        },
      })
      props.promise(true)
      props.close()
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}
  
const __returned__ = { props, store, emit, $t, load, dataIsSended, form, currentResource, request, fields, send, ref, watch, get useSubmit() { return useSubmit }, get useConfirm() { return useConfirm }, get useUserStore() { return useUserStore }, get useField() { return useField }, get optionsGetter() { return optionsGetter }, get useModalOpener() { return useModalOpener }, get clientCreateResource() { return clientCreateResource }, get clientUpdateResource() { return clientUpdateResource }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})